/*
JS Components
*/

import "./forms/input-file";
import "./quote-form/index--split";
import "./choose-form/index--split";
import "./selector/index--split";
import "./required-field/index--split";
import "./date-field/index--split";
import "./site-header";
import "./site-header-narrow";
import "./site-nav-narrow";
import './modal/index';
import './epi-blocks';
import './alerts';
import './app-install-prompt';
import './wysiwyg/index';
import './a-modal/index--split';
import './disclaimer/index';


// WEBPACK FOOTER //
// ./project/client/src/core/components/index.js